import * as React from "react";
import { cn } from "@/lib/utils";

interface TableHeadProps extends React.ThHTMLAttributes<HTMLTableCellElement> {
    /** When explicitly set to `false` the element is not rendered. */
    visible?: boolean;
}

const TableHead = React.forwardRef<HTMLTableCellElement, TableHeadProps>(
    ({ visible, className, ...props }, ref) => {
        if (visible === false) return null;
        return (
            <th
                ref={ref}
                className={cn(
                    "h-10 px-2.5 text-left align-middle font-medium text-table-header-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
                    className,
                )}
                {...props}
            />
        );
    },
);
TableHead.displayName = "TableHead";

export { TableHead };
export type { TableHeadProps };
